import React from 'react';
import PropTypes from 'prop-types';
import { componentsPropType, stylesPropType, vmPropTypes } from '../../global-prop-types';
import ComponentsArrRenderer from '../core/ComponentsArrRenderer';
import AnyErrorBoundary from '../global/AnyErrorBoundary';

const HeadBanner = (props) => {
  const {
    styles,
    image,
    parent = [],
    components = [],
    variant,
    ...restProps
  } = props;
  return (
    <AnyErrorBoundary>
      <div
        className={`d-flex ${variant || ''}`}
        style={styles?.wrapper}
      >
        <ComponentsArrRenderer
          parent={[...parent, 'HeadBanner']}
          components={components}
          {...restProps}
        />
      </div>
    </AnyErrorBoundary>
  );
};

HeadBanner.propTypes = {
  variant: PropTypes.string,
  styles: stylesPropType,
  image: PropTypes.string,
  components: componentsPropType,
  parent: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])),
};

HeadBanner.defaultProps = {
  variant: '',
  styles: {
    wrapper: {
      background: 'linear-gradient(to right, #E52330BF, transparent)',
      height: '184px',
      borderRadius: '0px 0px 115px 0px',
      marginBottom: '32px'
    }
  },
  components: []
};

HeadBanner.vmPropTypes = {
  variant: vmPropTypes.className,
  styles: {
    wrapper: {
      background: vmPropTypes.styles,
      height: vmPropTypes.styles,
      borderRadius: vmPropTypes.styles,
      marginBottom: vmPropTypes.styles,
    }
  },
  components: vmPropTypes.components
};

export default HeadBanner;
